import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertAnalyzesGroupsDemoService {

  private _groups: IRollupGroup[];

  constructor() {
    this._groups =
      [
        { Code: "em-4", Title: "Grpup 1" },
        { Code: "em-1", Title: "Grpup 2" },
        { Code: "em-2", Title: "Grpup 3" },
        { Code: "glbl-res-overflow", Title: "Grpup 4" },
        { Code: "glbl-res", Title: "Grpup 5" }
      ];
  }

  get() {
    return of(this._groups);
  }
}

export interface IRollupGroup {
  Code: string;
  Title: string;
}
